import axios from 'axios';

import { settings } from './settings';

const SERVER_URL = settings.endpoint;

function getPostMedia(postId){

	return axios.get(`${ SERVER_URL }/favorites/getPictures?postId=${ postId }`);

}



function getSpaceCategories(token, postId){

	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'x-access-token': token
		}
	}

	return axios.get(`${ SERVER_URL }/spaces/getCategories?postId=${ postId }`, config);

}



function getSpaceDetails(token, postId){

	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'x-access-token': token
		}
	}

	return axios.get(`${ SERVER_URL }/spaces/getDetails?postId=${ postId }`, config);

}

export { getPostMedia, getSpaceCategories, getSpaceDetails };
